import { lazy } from 'react';

export const CandidatesAsync = lazy(() => import('./candidates.component'));
